// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.venuesPage {
  width: 100%;
  max-width: none;
  min-width: 0;
  margin: 0;
  padding-bottom: 32px;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.venuesPage__content {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.venuesPage__listActions {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.venuesPage__tableCard > .venuesPage__listActions {
  padding: 0;
}

.venuesPage__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 64px;
  padding: 11px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.venuesPage__toolbarTitle {
  display: flex;
  align-items: center;
  gap: 8px;
}

.venuesPage__toolbarTitle strong {
  color: var(--text-strong, #142033);
  font-size: 22px;
  line-height: 1.1;
  font-weight: 800;
}

.venuesPage__toolbarTitle span {
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef2f6;
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 700;
}

.venuesPage__search {
  position: relative;
  display: flex;
  width: min(340px, 100%);
  min-width: 0;
  flex-direction: column;
}

.venuesPage__unionHeader {
  display: flex;
  width: calc(100% + 56px);
  min-height: 82px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: -40px 0 0 -28px;
  padding: 14px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.venuesPage__unionHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  line-height: 1.2;
}

.venuesPage__unionHeader p {
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.venuesPage__unionSummary {
  display: flex;
  width: calc(100% + 56px);
  min-height: 58px;
  align-items: center;
  gap: 10px;
  margin: 0 0 18px -28px;
  padding: 12px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.venuesPage__summaryChip,
.venuesPage__summaryContext {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 7px;
  padding: 5px 11px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 650;
}

.venuesPage__summaryChip b {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 15px;
  font-weight: 800;
}

.venuesPage__summaryChip i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.venuesPage__summaryChip--home {
  border-color: #cce7d7;
  background: #f1faf5;
  color: #2f8b53;
}

.venuesPage__summaryChip--away {
  border-color: #cbdff0;
  background: #f1f7fc;
  color: #227ebd;
}

.venuesPage__summaryContext {
  margin-left: auto;
  color: var(--text-muted, #64748b);
}

.venuesPage__search > span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.venuesPage__search input {
  width: 100%;
  height: var(--control-h-md, 40px);
  min-width: 0;
  padding: 0 38px 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  outline: none;
  background: var(--surface-card, #fff);
  box-shadow: none;
  color: var(--text-strong, #0f172a);
  font-size: var(--text-md, 14px);
}

.venuesPage__search button {
  position: absolute;
  top: 50%;
  right: 8px;
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-family: inherit;
  font-size: 19px;
  line-height: 1;
  cursor: pointer;
}

.venuesPage__search button:hover,
.venuesPage__search button:focus-visible {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
  outline: none;
}

.venuesPage__search input:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.venuesPage__createBtn,
.venuesPage__drawerEdit {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 15px;
  border: 1px solid #227ebd;
  border-radius: 9px;
  background: #227ebd;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.venuesPage__createBtn:hover {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
  color: #fff;
}

.venuesPage__createBtn svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.9;
}

.venuesPage__selection {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 13px;
  border: 1px solid #f1c4ca;
  border-radius: 10px;
  background: #fff5f6;
  color: #8f2c39;
  font-size: 13px;
  font-weight: 650;
}

.venuesPage__selection > div {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 8px;
  margin-left: 0;
}

.venuesPage__tableCard {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: #fff;
}

.venuesPage__tableScroll {
  overflow-x: auto;
}

.venuesPage__table {
  width: 100%;
  min-width: 650px;
  border-collapse: collapse;
}

.venuesPage__table th {
  height: 44px;
  padding: 0 14px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--slate-25, #f8fafc);
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.045em;
  text-align: left;
  text-transform: uppercase;
}

.venuesPage__table th button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}

.venuesPage__table th button span {
  color: #94a3b8;
  font-size: 12px;
}

.venuesPage__table td {
  height: 56px;
  padding: 8px 14px;
  border-bottom: 1px solid #e8edf2;
  color: var(--text-body, #334155);
  font-size: 13px;
  vertical-align: middle;
}

.venuesPage__table tbody tr:last-child td {
  border-bottom: 0;
}

.venuesPage__table tbody tr {
  cursor: pointer;
  transition: background 0.14s ease;
}

.venuesPage__table tbody tr:hover {
  background: #f8fbfd;
}

.venuesPage__checkCell {
  width: 46px;
  padding-right: 6px !important;
  text-align: center !important;
}

.venuesPage__checkCell input {
  width: 16px;
  height: 16px;
  accent-color: var(--blue-600, #227ebd);
  cursor: pointer;
}

.venuesPage__venueCell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.venuesPage__venueCell strong {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 650;
}

.venuesPage__pin {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #e9f1fa;
  color: #227ebd;
}

.venuesPage__pin--home {
  background: #e7f3ec;
  color: #2f9e5a;
}

.venuesPage__pin svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.venuesPage__table .venuesPage__postcode {
  color: #445367;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12.5px;
}

.venuesPage__type {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.venuesPage__type i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.venuesPage__empty {
  height: 140px !important;
  color: var(--text-muted, #69778a) !important;
  text-align: center;
}

.venuesPage__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  flex-wrap: wrap;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.venuesPage__paginationSummary {
  margin-right: 4px;
}

.venuesPage__paginationEllipsis {
  min-width: 18px;
  color: var(--text-subtle, #94a3b8);
  text-align: center;
}

.venuesPage__pageBtn,
.venuesPage__paginationNav {
  display: inline-flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.venuesPage__pageBtn {
  min-width: 34px;
  padding: 0 8px;
}

.venuesPage__paginationNav {
  min-width: 78px;
  padding: 0 13px;
}

.venuesPage__pageBtn:hover,
.venuesPage__paginationNav:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df);
  color: var(--blue-700, #155d8c);
}

.venuesPage__pageBtn.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.venuesPage__paginationNav:disabled {
  cursor: default;
  opacity: 0.45;
}

.venuesPage__deleteBtn,
.venuesPage__drawerDelete,
.venuesPage__clearBtn {
  min-height: 32px;
  padding: 0 11px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.venuesPage__deleteBtn {
  border: 1px solid transparent;
  background: var(--red-500, #da4453);
  color: #fff;
}

.venuesPage__deleteBtn:hover {
  background: var(--red-600, #c4313f);
  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);
}

.venuesPage__drawerDelete {
  border: 1px solid #df7b88;
  background: #fff;
  color: #b23343;
}

.venuesPage__clearBtn {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
}

.venuesPage__clearBtn:hover {
  text-decoration: underline;
}

.venuesPage .bTable,
.venuesPage .table-responsive,
.venuesPage [class*='Grid'] {
  border-radius: 12px;
}

.venuesPage__drawerView {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.venuesPage__mapCard {
  position: relative;
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
}

.venuesPage__viewMap {
  display: block !important;
  width: 100% !important;
  height: 240px;
  margin: 0 !important;
}

.venuesPage__postcodeChip {
  position: absolute;
  bottom: 10px;
  left: 10px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  color: #142033;
  font-family: monospace;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.16);
}

.venuesPage__detailRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 2px;
  border-bottom: 1px solid #e4eaf0;
}

.venuesPage__detailRow > span {
  color: #69778a;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.venuesPage__postcode {
  font-family: monospace;
}

.venuesPage__type {
  padding: 4px 9px;
  border-radius: 999px;
  background: #e9f1fa;
  color: #227ebd;
  font-size: 11px;
}

.venuesPage__type--home {
  background: #e7f3ec;
  color: #2f9e5a;
}

.venuesPage__drawerActions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 18px;
  padding-top: 15px;
  border-top: 1px solid #dbe3ec;
}

.venuesPage__editDrawer .schoolStructure-drawer__body {
  padding-top: 22px;
  overflow-x: hidden;
}

@media (max-width: 767px) {
  .venuesPage__unionHeader,
  .venuesPage__unionSummary {
    width: 100vw;
    margin-left: -28px;
  }

  .venuesPage__unionHeader {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    margin-top: -36px;
  }

  .venuesPage__unionSummary {
    overflow-x: auto;
  }

  .venuesPage__summaryContext {
    margin-left: 0;
  }

  .venuesPage__toolbar,
  .venuesPage__selection {
    align-items: stretch;
    flex-direction: column;
  }

  .venuesPage__search {
    width: 100%;
  }

  .venuesPage__toolbarTitle {
    margin-right: 0;
  }

  .venuesPage__toolbar > .venuesPage__createBtn {
    margin-left: 0;
  }

  .venuesPage__selection > div {
    margin-left: 0;
  }
}

/* Venues list — shared refreshed list shell. */
.venuesScreen {
  width: 100%;
  min-width: 0;
}

.venuesPage__pageHeader {
  display: flex;
  width: calc(100% + 48px);
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.venuesPage__pageTitle {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.venuesPage__pageTitle h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', var(--font-body, 'Public Sans', system-ui, sans-serif));
  font-size: 22px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.015em;
}

.venuesPage__pageTitle > span {
  display: inline-flex;
  min-width: 24px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11.5px;
  font-weight: 800;
}

.venuesPage__tableCard {
  overflow: visible;
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.venuesPage__filterBtn,
.venuesPage__columnsBtn {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
}

.venuesPage__filterBtn:hover,
.venuesPage__filterBtn.is-active,
.venuesPage__columnsBtn:hover,
.venuesPage__columnsBtn.is-active {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.venuesPage__toolbarIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  background: currentColor;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: 16px 16px;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 16px 16px;
}

.venuesPage__toolbarIcon--filter {
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
}

.venuesPage__toolbarIcon--columns {
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E");
}

.venuesPage__actionBadge {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
}

.venuesPage__filterBtn.is-active .venuesPage__actionBadge {
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.venuesPage__columns {
  position: relative;
  display: flex;
}

.venuesPage__columnsMenu {
  position: absolute;
  z-index: 40;
  top: 44px;
  right: 0;
  width: 260px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
}

.venuesPage__columnsMenu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 8px 9px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.venuesPage__columnsMenu header button {
  padding: 0;
  border: 0;
  background: none;
  color: var(--blue-600, #1a6da3);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  text-transform: none;
}

.venuesPage__columnsMenu label {
  display: flex;
  min-height: 36px;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 7px 8px;
  border-radius: 7px;
  color: var(--text-body, #334155);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}

.venuesPage__columnsMenu label:hover {
  background: var(--surface-page, #f8fafc);
}

.venuesPage__columnsMenu label small {
  margin-left: auto;
  color: var(--text-subtle, #94a3b8);
  font-size: 10.5px;
  font-weight: 650;
}

.venuesPage__columnsMenu label.is-required {
  cursor: default;
}

.venuesPage__columnsMenu input {
  width: 16px;
  height: 16px;
  accent-color: var(--action-primary, #227ebd);
}

.venuesPage__columnsMenu label.is-required input {
  opacity: 0.62;
  cursor: not-allowed;
}

.venuesPage__filterChips {
  display: flex;
  min-height: 44px;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.venuesPage__filterChips > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 4px 9px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.venuesPage__filterChips button {
  width: auto;
  min-width: 0;
  height: auto;
  min-height: 0;
  margin-left: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  cursor: pointer;
  font: inherit;
  font-weight: 800;
}

.venuesPage__filterChips > .venuesPage__filterChipsClear {
  margin-left: 0;
  color: var(--blue-600, #1a6da3);
  font-size: 12px;
}

.venuesPage__filters {
  position: fixed;
  z-index: 1050;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  flex-direction: column;
  align-items: stretch;
  gap: 18px;
  margin: 0;
  padding: 18px 18px 88px;
  overflow-y: auto;
  border: 0;
  border-left: 1px solid #d9e2ec;
  background: var(--surface-card, #fff);
  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);
}

.venuesPage__filters > header {
  display: flex;
  min-height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #e6ebf1;
}

.venuesPage__filters > header h2 {
  margin: 0;
  color: #172b4d;
  font-size: 16px;
  font-weight: 800;
}

.venuesPage__filters > header > button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #667085;
  cursor: pointer;
  font-size: 23px;
}

.venuesPage__filterField {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.venuesPage__filterField input {
  width: 100%;
  height: 40px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  outline: 0;
  color: var(--text-body, #334155);
  font-size: 13px;
}

.venuesPage__filterField input:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.venuesPage__filterGroup {
  margin: 0;
  padding: 0;
  border: 0;
}

.venuesPage__filterGroup legend {
  margin-bottom: 8px;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.venuesPage__filterGroup > div {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.venuesPage__filterGroup button {
  min-height: 30px;
  padding: 5px 11px;
  border: 1px solid #d7e0e9;
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #475569);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 650;
}

.venuesPage__filterGroup button:hover {
  border-color: #8fbfdd;
  background: #f5faff;
  color: var(--blue-700, #155d8c);
}

.venuesPage__filterGroup button.is-selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.venuesPage__filters > .venuesPage__filtersActions {
  position: fixed;
  z-index: 2;
  right: 0;
  bottom: 0;
  width: 360px;
  max-width: calc(100vw - 20px);
}

.venuesPage__selection {
  margin: 10px 16px;
}

.venuesPage__table tbody tr.is-selected {
  background: var(--blue-50, #eef6fc);
}

.venuesPage__openCell {
  width: 44px;
  text-align: right !important;
}

.venuesPage__openBtn {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  opacity: 0;
  background: transparent;
  color: var(--text-subtle, #94a3b8);
  cursor: pointer;
  font-size: 23px;
  line-height: 1;
  transition: opacity 120ms ease, background-color 120ms ease, color 120ms ease;
}

.venuesPage__table tbody tr:hover .venuesPage__openBtn,
.venuesPage__table tbody tr.is-selected .venuesPage__openBtn,
.venuesPage__openBtn:focus-visible {
  opacity: 1;
}

.venuesPage__openBtn:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.venuesPage__empty {
  height: 260px !important;
}

.venuesPage__empty > div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 7px;
}

.venuesPage__emptyIcon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-600, #1a6da3);
}

.venuesPage__emptyIcon svg {
  width: 21px;
  height: 21px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.venuesPage__empty strong {
  color: var(--text-strong, #0f172a);
  font-size: 16px;
  font-weight: 800;
}

.venuesPage__empty p {
  margin: 0 0 5px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.venuesPage__emptyAction {
  min-height: 38px;
  padding: 0 13px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
}

.venuesPage__pagination > .bPagination--modern {
  width: 100%;
}

@media (max-width: 1217px) {
  .venuesPage__pageHeader {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}

@media (max-width: 767px) {
  .venuesPage {
    padding-bottom: 24px;
  }

  .venuesPage__pageHeader {
    width: 100vw;
    min-height: 64px;
    margin-top: -20px;
    margin-bottom: 14px;
    padding: 0 16px;
  }

  .venuesPage__pageHeader > .venuesPage__createBtn {
    padding: 0 11px;
    font-size: 0;
  }

  .venuesPage__pageHeader > .venuesPage__createBtn svg {
    width: 18px;
    height: 18px;
  }

  .venuesPage__toolbar {
    align-items: stretch;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 12px;
  }

  .venuesPage__search {
    width: 100%;
  }

  .venuesPage__filters,
  .venuesPage__filters > .venuesPage__filtersActions {
    width: 100vw;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/School/Venues/Venues.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+CAA+C;EAC/C,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,sBAAsB;EACtB,gDAAgD;EAChD,oCAAoC;EACpC,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,0GAA0G;EAC1G,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8DAA8D;AAChE;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8MAA8M;EAC9M,sNAAsN;AACxN;;AAEA;EACE,gRAAgR;EAChR,wRAAwR;AAC1R;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,qCAAqC;EACrC,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,UAAU;EACV,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,cAAc;EACd,6EAA6E;AAC/E;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".venuesPage {\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  margin: 0;\n  padding-bottom: 32px;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.venuesPage__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.venuesPage__listActions {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.venuesPage__tableCard > .venuesPage__listActions {\n  padding: 0;\n}\n\n.venuesPage__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 64px;\n  padding: 11px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.venuesPage__toolbarTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.venuesPage__toolbarTitle strong {\n  color: var(--text-strong, #142033);\n  font-size: 22px;\n  line-height: 1.1;\n  font-weight: 800;\n}\n\n.venuesPage__toolbarTitle span {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.venuesPage__search {\n  position: relative;\n  display: flex;\n  width: min(340px, 100%);\n  min-width: 0;\n  flex-direction: column;\n}\n\n.venuesPage__unionHeader {\n  display: flex;\n  width: calc(100% + 56px);\n  min-height: 82px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin: -40px 0 0 -28px;\n  padding: 14px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.venuesPage__unionHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.venuesPage__unionHeader p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.venuesPage__unionSummary {\n  display: flex;\n  width: calc(100% + 56px);\n  min-height: 58px;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 18px -28px;\n  padding: 12px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.venuesPage__summaryChip,\n.venuesPage__summaryContext {\n  display: inline-flex;\n  min-height: 32px;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 11px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.venuesPage__summaryChip b {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.venuesPage__summaryChip i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.venuesPage__summaryChip--home {\n  border-color: #cce7d7;\n  background: #f1faf5;\n  color: #2f8b53;\n}\n\n.venuesPage__summaryChip--away {\n  border-color: #cbdff0;\n  background: #f1f7fc;\n  color: #227ebd;\n}\n\n.venuesPage__summaryContext {\n  margin-left: auto;\n  color: var(--text-muted, #64748b);\n}\n\n.venuesPage__search > span {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n\n.venuesPage__search input {\n  width: 100%;\n  height: var(--control-h-md, 40px);\n  min-width: 0;\n  padding: 0 38px 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  outline: none;\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n  color: var(--text-strong, #0f172a);\n  font-size: var(--text-md, 14px);\n}\n\n.venuesPage__search button {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  display: inline-flex;\n  width: 26px;\n  height: 26px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transform: translateY(-50%);\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-family: inherit;\n  font-size: 19px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.venuesPage__search button:hover,\n.venuesPage__search button:focus-visible {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n  outline: none;\n}\n\n.venuesPage__search input:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.venuesPage__createBtn,\n.venuesPage__drawerEdit {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 15px;\n  border: 1px solid #227ebd;\n  border-radius: 9px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.venuesPage__createBtn:hover {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n  color: #fff;\n}\n\n.venuesPage__createBtn svg {\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: 1.9;\n}\n\n.venuesPage__selection {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 13px;\n  border: 1px solid #f1c4ca;\n  border-radius: 10px;\n  background: #fff5f6;\n  color: #8f2c39;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.venuesPage__selection > div {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  gap: 8px;\n  margin-left: 0;\n}\n\n.venuesPage__tableCard {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.venuesPage__tableScroll {\n  overflow-x: auto;\n}\n\n.venuesPage__table {\n  width: 100%;\n  min-width: 650px;\n  border-collapse: collapse;\n}\n\n.venuesPage__table th {\n  height: 44px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--slate-25, #f8fafc);\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.045em;\n  text-align: left;\n  text-transform: uppercase;\n}\n\n.venuesPage__table th button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n\n.venuesPage__table th button span {\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.venuesPage__table td {\n  height: 56px;\n  padding: 8px 14px;\n  border-bottom: 1px solid #e8edf2;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.venuesPage__table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.venuesPage__table tbody tr {\n  cursor: pointer;\n  transition: background 0.14s ease;\n}\n\n.venuesPage__table tbody tr:hover {\n  background: #f8fbfd;\n}\n\n.venuesPage__checkCell {\n  width: 46px;\n  padding-right: 6px !important;\n  text-align: center !important;\n}\n\n.venuesPage__checkCell input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--blue-600, #227ebd);\n  cursor: pointer;\n}\n\n.venuesPage__venueCell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.venuesPage__venueCell strong {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 650;\n}\n\n.venuesPage__pin {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #e9f1fa;\n  color: #227ebd;\n}\n\n.venuesPage__pin--home {\n  background: #e7f3ec;\n  color: #2f9e5a;\n}\n\n.venuesPage__pin svg {\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.venuesPage__table .venuesPage__postcode {\n  color: #445367;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12.5px;\n}\n\n.venuesPage__type {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.venuesPage__type i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.venuesPage__empty {\n  height: 140px !important;\n  color: var(--text-muted, #69778a) !important;\n  text-align: center;\n}\n\n.venuesPage__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  flex-wrap: wrap;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.venuesPage__paginationSummary {\n  margin-right: 4px;\n}\n\n.venuesPage__paginationEllipsis {\n  min-width: 18px;\n  color: var(--text-subtle, #94a3b8);\n  text-align: center;\n}\n\n.venuesPage__pageBtn,\n.venuesPage__paginationNav {\n  display: inline-flex;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.venuesPage__pageBtn {\n  min-width: 34px;\n  padding: 0 8px;\n}\n\n.venuesPage__paginationNav {\n  min-width: 78px;\n  padding: 0 13px;\n}\n\n.venuesPage__pageBtn:hover,\n.venuesPage__paginationNav:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df);\n  color: var(--blue-700, #155d8c);\n}\n\n.venuesPage__pageBtn.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.venuesPage__paginationNav:disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.venuesPage__deleteBtn,\n.venuesPage__drawerDelete,\n.venuesPage__clearBtn {\n  min-height: 32px;\n  padding: 0 11px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.venuesPage__deleteBtn {\n  border: 1px solid transparent;\n  background: var(--red-500, #da4453);\n  color: #fff;\n}\n\n.venuesPage__deleteBtn:hover {\n  background: var(--red-600, #c4313f);\n  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);\n}\n\n.venuesPage__drawerDelete {\n  border: 1px solid #df7b88;\n  background: #fff;\n  color: #b23343;\n}\n\n.venuesPage__clearBtn {\n  margin-left: auto;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n}\n\n.venuesPage__clearBtn:hover {\n  text-decoration: underline;\n}\n\n.venuesPage .bTable,\n.venuesPage .table-responsive,\n.venuesPage [class*='Grid'] {\n  border-radius: 12px;\n}\n\n.venuesPage__drawerView {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.venuesPage__mapCard {\n  position: relative;\n  margin-bottom: 12px;\n  overflow: hidden;\n  border: 1px solid #dbe3ec;\n  border-radius: 12px;\n}\n\n.venuesPage__viewMap {\n  display: block !important;\n  width: 100% !important;\n  height: 240px;\n  margin: 0 !important;\n}\n\n.venuesPage__postcodeChip {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #142033;\n  font-family: monospace;\n  font-size: 12px;\n  font-weight: 700;\n  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.16);\n}\n\n.venuesPage__detailRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 13px 2px;\n  border-bottom: 1px solid #e4eaf0;\n}\n\n.venuesPage__detailRow > span {\n  color: #69778a;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.venuesPage__postcode {\n  font-family: monospace;\n}\n\n.venuesPage__type {\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: #e9f1fa;\n  color: #227ebd;\n  font-size: 11px;\n}\n\n.venuesPage__type--home {\n  background: #e7f3ec;\n  color: #2f9e5a;\n}\n\n.venuesPage__drawerActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 18px;\n  padding-top: 15px;\n  border-top: 1px solid #dbe3ec;\n}\n\n.venuesPage__editDrawer .schoolStructure-drawer__body {\n  padding-top: 22px;\n  overflow-x: hidden;\n}\n\n@media (max-width: 767px) {\n  .venuesPage__unionHeader,\n  .venuesPage__unionSummary {\n    width: 100vw;\n    margin-left: -28px;\n  }\n\n  .venuesPage__unionHeader {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: -36px;\n  }\n\n  .venuesPage__unionSummary {\n    overflow-x: auto;\n  }\n\n  .venuesPage__summaryContext {\n    margin-left: 0;\n  }\n\n  .venuesPage__toolbar,\n  .venuesPage__selection {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .venuesPage__search {\n    width: 100%;\n  }\n\n  .venuesPage__toolbarTitle {\n    margin-right: 0;\n  }\n\n  .venuesPage__toolbar > .venuesPage__createBtn {\n    margin-left: 0;\n  }\n\n  .venuesPage__selection > div {\n    margin-left: 0;\n  }\n}\n\n/* Venues list — shared refreshed list shell. */\n.venuesScreen {\n  width: 100%;\n  min-width: 0;\n}\n\n.venuesPage__pageHeader {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 70px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.venuesPage__pageTitle {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n\n.venuesPage__pageTitle h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', var(--font-body, 'Public Sans', system-ui, sans-serif));\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n}\n\n.venuesPage__pageTitle > span {\n  display: inline-flex;\n  min-width: 24px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11.5px;\n  font-weight: 800;\n}\n\n.venuesPage__tableCard {\n  overflow: visible;\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));\n}\n\n.venuesPage__filterBtn,\n.venuesPage__columnsBtn {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.venuesPage__filterBtn:hover,\n.venuesPage__filterBtn.is-active,\n.venuesPage__columnsBtn:hover,\n.venuesPage__columnsBtn.is-active {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.venuesPage__toolbarIcon {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  background: currentColor;\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: 16px 16px;\n  -webkit-mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: 16px 16px;\n}\n\n.venuesPage__toolbarIcon--filter {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n}\n\n.venuesPage__toolbarIcon--columns {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\");\n}\n\n.venuesPage__actionBadge {\n  display: inline-flex;\n  min-width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.venuesPage__filterBtn.is-active .venuesPage__actionBadge {\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.venuesPage__columns {\n  position: relative;\n  display: flex;\n}\n\n.venuesPage__columnsMenu {\n  position: absolute;\n  z-index: 40;\n  top: 44px;\n  right: 0;\n  width: 260px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);\n}\n\n.venuesPage__columnsMenu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 8px 9px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.venuesPage__columnsMenu header button {\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--blue-600, #1a6da3);\n  cursor: pointer;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: none;\n}\n\n.venuesPage__columnsMenu label {\n  display: flex;\n  min-height: 36px;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  padding: 7px 8px;\n  border-radius: 7px;\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.venuesPage__columnsMenu label:hover {\n  background: var(--surface-page, #f8fafc);\n}\n\n.venuesPage__columnsMenu label small {\n  margin-left: auto;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 10.5px;\n  font-weight: 650;\n}\n\n.venuesPage__columnsMenu label.is-required {\n  cursor: default;\n}\n\n.venuesPage__columnsMenu input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.venuesPage__columnsMenu label.is-required input {\n  opacity: 0.62;\n  cursor: not-allowed;\n}\n\n.venuesPage__filterChips {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.venuesPage__filterChips > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.venuesPage__filterChips button {\n  width: auto;\n  min-width: 0;\n  height: auto;\n  min-height: 0;\n  margin-left: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  cursor: pointer;\n  font: inherit;\n  font-weight: 800;\n}\n\n.venuesPage__filterChips > .venuesPage__filterChipsClear {\n  margin-left: 0;\n  color: var(--blue-600, #1a6da3);\n  font-size: 12px;\n}\n\n.venuesPage__filters {\n  position: fixed;\n  z-index: 1050;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  flex-direction: column;\n  align-items: stretch;\n  gap: 18px;\n  margin: 0;\n  padding: 18px 18px 88px;\n  overflow-y: auto;\n  border: 0;\n  border-left: 1px solid #d9e2ec;\n  background: var(--surface-card, #fff);\n  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.venuesPage__filters > header {\n  display: flex;\n  min-height: 34px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e6ebf1;\n}\n\n.venuesPage__filters > header h2 {\n  margin: 0;\n  color: #172b4d;\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.venuesPage__filters > header > button {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #667085;\n  cursor: pointer;\n  font-size: 23px;\n}\n\n.venuesPage__filterField {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.venuesPage__filterField input {\n  width: 100%;\n  height: 40px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  outline: 0;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n}\n\n.venuesPage__filterField input:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.venuesPage__filterGroup {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.venuesPage__filterGroup legend {\n  margin-bottom: 8px;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.venuesPage__filterGroup > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.venuesPage__filterGroup button {\n  min-height: 30px;\n  padding: 5px 11px;\n  border: 1px solid #d7e0e9;\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #475569);\n  cursor: pointer;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.venuesPage__filterGroup button:hover {\n  border-color: #8fbfdd;\n  background: #f5faff;\n  color: var(--blue-700, #155d8c);\n}\n\n.venuesPage__filterGroup button.is-selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.venuesPage__filters > .venuesPage__filtersActions {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  bottom: 0;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n}\n\n.venuesPage__selection {\n  margin: 10px 16px;\n}\n\n.venuesPage__table tbody tr.is-selected {\n  background: var(--blue-50, #eef6fc);\n}\n\n.venuesPage__openCell {\n  width: 44px;\n  text-align: right !important;\n}\n\n.venuesPage__openBtn {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  opacity: 0;\n  background: transparent;\n  color: var(--text-subtle, #94a3b8);\n  cursor: pointer;\n  font-size: 23px;\n  line-height: 1;\n  transition: opacity 120ms ease, background-color 120ms ease, color 120ms ease;\n}\n\n.venuesPage__table tbody tr:hover .venuesPage__openBtn,\n.venuesPage__table tbody tr.is-selected .venuesPage__openBtn,\n.venuesPage__openBtn:focus-visible {\n  opacity: 1;\n}\n\n.venuesPage__openBtn:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.venuesPage__empty {\n  height: 260px !important;\n}\n\n.venuesPage__empty > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.venuesPage__emptyIcon {\n  display: inline-flex;\n  width: 42px;\n  height: 42px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 11px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-600, #1a6da3);\n}\n\n.venuesPage__emptyIcon svg {\n  width: 21px;\n  height: 21px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.venuesPage__empty strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.venuesPage__empty p {\n  margin: 0 0 5px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.venuesPage__emptyAction {\n  min-height: 38px;\n  padding: 0 13px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.venuesPage__pagination > .bPagination--modern {\n  width: 100%;\n}\n\n@media (max-width: 1217px) {\n  .venuesPage__pageHeader {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 767px) {\n  .venuesPage {\n    padding-bottom: 24px;\n  }\n\n  .venuesPage__pageHeader {\n    width: 100vw;\n    min-height: 64px;\n    margin-top: -20px;\n    margin-bottom: 14px;\n    padding: 0 16px;\n  }\n\n  .venuesPage__pageHeader > .venuesPage__createBtn {\n    padding: 0 11px;\n    font-size: 0;\n  }\n\n  .venuesPage__pageHeader > .venuesPage__createBtn svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .venuesPage__toolbar {\n    align-items: stretch;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 12px;\n  }\n\n  .venuesPage__search {\n    width: 100%;\n  }\n\n  .venuesPage__filters,\n  .venuesPage__filters > .venuesPage__filtersActions {\n    width: 100vw;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
